import { useContext } from 'react'
import { UGEContext } from '../context'
import CropOverlay from './crop'

type Props = {
    className?: string
}

const UGEOverlay = ({ className }: Props) => {
    const { activeEditor } = useContext(UGEContext)

    switch (activeEditor) {
        case 'crop':
            return <CropOverlay className={className} />
        default:
            return null
    }
}

export default UGEOverlay
